var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVideoShare = function SvgIconVideoShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.5a3 3 0 1 0-2.934-2.371L7.763 8.03a3 3 0 1 0 0 3.94l3.803 1.902a3 3 0 1 0 .671-1.341l-3.803-1.902a3 3 0 0 0 0-1.258l3.803-1.901c.55.631 1.36 1.03 2.263 1.03"
  })));
};
export default SvgIconVideoShare;